import React, { Component, Fragment } from 'react';
import { Button } from '@material-ui/core';

import { useNotify } from 'react-admin';
import SendIcon from '@material-ui/icons/Send';
import ReportIcon from '@material-ui/icons/Report';
import CheckIcon from '@material-ui/icons/Check';
import GoogleReviewPopUp from '../../src/components/GoogleReviewPopUp'
import {
  getZ3PConfigValue,
} from '../helper';

class SwBulkActionButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupVisible: false,
    };
  }

  //  const [isPopupVisible, setPopupVisible] = useState(false);
  openPopup = () => {
    this.setState(
      {
        isPopupVisible: true,
      })
  }

  closePopup = () => {
    this.setState(
      {
        isPopupVisible: false,
      })
  }

  componentDidMount() {
    // this.getToken();
  }
  onClickGoogleReview = () => {
    // alert("eee")
    this.openPopup()
  }
  render() {
    const googleReviewUrl = getZ3PConfigValue('google_review_url');
    return (
      <>
        <GoogleReviewPopUp show={this.state.isPopupVisible} onClose={this.closePopup} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: '12px',
            flexWrap: 'wrap', // optional: wraps buttons on small screens
          }}
        >
          <b>Actions:</b>
          <Button onClick={this.onClickGoogleReview}
            className="cancel_btn"
            disabled={false}>
            <img
              src="https://www.google.com/favicon.ico"
              alt="Google"
              style={styles.googleIcon}
            />
            <span>Request Google Review via SMS</span>
            <SendIcon fontSize="small" />
          </Button>
          <Button
            className="cancel_btn"
            disabled={true}>
            Cancel Appointments
            <ReportIcon fontSize="small" />
          </Button>
          <Button
            className="cancel_btn"
            disabled={true}>
            Confirm Appointments
            <CheckIcon fontSize="small" />
          </Button>
          <Button style={{ pointerEvents: 'none', cursor: 'default', opacity: 0.5, }} className="send_email" disabled={false}>
            Send Reschedule Email
            <SendIcon fontSize="small" />
          </Button>
        </div>
      </>
    );
  }
}

const styles ={
  header: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    margin: 0,
  },
  googleIcon: {
    width: '20px',
    height: '20px',
    paddingRight: '6px',
  },
}

export default (props) => {
  const notify = useNotify();
  return <SwBulkActionButtons {...props} notify={notify} />;
};
